// Copyright (c) Siemens AG 2026 ALL RIGHTS RESERVED.
//
// mySiESTA

import LdapUserModal from '../../modals/ldap_user_modal'

up.compiler('.user-form', (element) => {
  up.on(element, 'click', '.user-form--import-ldap', function(event) {
    event.preventDefault()

    new LdapUserModal({ onlyLdap: true }).open().then((user) => {
      for (const field in user) {
        const value = user[field]
        element.querySelectorAll(`input[name$="[${field}]"], select[name$="[${field}]"]`).forEach((inputOrSelect) => {
          if (inputOrSelect.type !== 'radio') {
            inputOrSelect.value = value
          }
        })
      }
    })
  })
})
